var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.breadcrumbs},[_c('div',{class:_vm.$style.path},[_vm._l((_vm.breadcrumb),function(item,index){return [_c('span',{key:index},[_c('router-link',{attrs:{"to":item.to}},[_vm._v(_vm._s(item.text))]),_c('span',{class:_vm.$style.arrow})],1)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }